export interface ReportCategory {
  value: string;
  label: string;
  subcategories: { value: string; label: string }[];
}

export const REPORT_CATEGORIES: ReportCategory[] = [
  {
    value: 'harassment',
    label: 'Harassment',
    subcategories: [
      { value: 'threatening_messages', label: 'Threatening messages' },
      { value: 'personal_attacks', label: 'Personal attacks' },
      { value: 'hate_speech', label: 'Hate speech' },
    ],
  },
  {
    value: 'spam',
    label: 'Spam',
    subcategories: [
      { value: 'repetitive_messages', label: 'Repetitive messages' },
      { value: 'unsolicited_promotion', label: 'Unsolicited promotion' },
      { value: 'bot_behavior', label: 'Bot behavior' },
    ],
  },
  {
    value: 'inappropriate_content',
    label: 'Inappropriate Content',
    subcategories: [
      { value: 'sexual_content', label: 'Sexual content' },
      { value: 'graphic_violence', label: 'Graphic violence' },
      { value: 'self_harm', label: 'Self-harm' },
    ],
  },
  {
    value: 'impersonation',
    label: 'Impersonation',
    subcategories: [
      { value: 'fake_identity', label: 'Fake identity' },
      { value: 'impersonating_public_figure', label: 'Impersonating a public figure' },
    ],
  },
  {
    value: 'scam_fraud',
    label: 'Scam / Fraud',
    subcategories: [
      { value: 'financial_scam', label: 'Financial scam' },
      { value: 'phishing', label: 'Phishing' },
      { value: 'fake_giveaway', label: 'Fake giveaway' },
    ],
  },
  {
    value: 'platform_abuse',
    label: 'Platform Abuse',
    subcategories: [
      { value: 'wash_trading', label: 'Wash trading' },
      { value: 'profile_farming', label: 'Profile farming' },
      { value: 'fake_followers', label: 'Fake followers' },
      { value: 'market_manipulation', label: 'Market manipulation' },
    ],
  },
  {
    value: 'other',
    label: 'Other',
    subcategories: [],
  },
];
